import React from 'react';
import './style.scss';

const AnimatedLogo = () => {
  return (
    <h2 className="animated-logo" dir="ltr">
      <span>k</span>
      <span>o</span>
      <span>o</span>
      <span>l</span>
      <span>e</span>
      <span>p</span>
      <span>o</span>
      <span>s</span>
      <span>h</span>
      <span>t</span>
      <span>i</span>
    </h2>
  );
};

export default AnimatedLogo;
